import { useState } from "react";
import BurguerMobile from "../../../../_+_Portal/components/Genericos/BurguerMobile/BurguerMobile";
// import FooterBar from "../../../../components/Genericos/Footer/FooterBar";
import HeaderbarHome from "../../../../_+_Portal/components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../../../_+_Portal/components/Genericos/Sidebar/Sidebar";
import { ContainerChildren } from "./localStyle";

const Layout = ({ children, positionSidebar, origen, state, nextFnc }) => {
  // Header Bar copiado
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };
  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };
  return (
    <>
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
        nextFnc={nextFnc}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <ContainerChildren>
        <Sidebar />
        {children}
      </ContainerChildren>
    </>
  );
};

export default Layout;
